module.exports = __webpack_public_path__ + "img/launch.9649cdae.png";